import {useTranslation} from 'react-i18next';
import * as css from './CustomSharePopup.css';
import useMobile from '../../hooks/useMobile';
import {email, facebookIcon, twitter, whatsApp, shareIcon} from './socialMediaIcons';
import {useSelector} from 'react-redux';
import Btn from '../button/btn/Btn';
import {getDomain} from '../../layout/eventMenu/formButtton/FormButtton';
import {shareContent, handleMobileShare} from '../../utils/shareUtils';
import ImagePopup from '../imagePopup/ImagePopup';
import {useField} from 'formik';
import {TShow} from '../prompotionPopup/PromotionPopup';
import InnerPop from '../newPopup/innerPop/InnerPop';

const CustomSharePopup = ({show}: {show: TShow}) => {
    const sharingOptions = [{text:'email', image: email},{text: 'twitter',image: twitter}, {text: 'whatsapp', image: whatsApp},{text: 'facebook', image: facebookIcon}, {text: 'customLead', image: shareIcon}];
    const {t} = useTranslation('event');
    const isMobile = useMobile();
    const eid = useSelector((state: any) => state.event.eid);
    const {title, landingPageUrl, domain, name, type} = useSelector((s: any) => s.event);
    const SHARE_REF = '30rw';
    const [{value: image},,imageHelpers] = useField('postImage.image');

    const getUrl = () =>{    
        const urlPath = getDomain(domain, landingPageUrl, name, type);
        return `${urlPath}?ref=${SHARE_REF}`;
    };
    const text = title;
    const eventLink = getUrl();
    const openLeadsPage = () => {
        window.open(`/e/${eid}/publish`, '_blank');
    };

    const share = async (platform: string) => {
        if(platform === 'customLead') {
            openLeadsPage();
            return;
        }
        await shareContent(platform, title, text, eventLink, image?.image);
    };

    const mobileShareHandler = async () => {
        await handleMobileShare(title, text, eventLink, image?.image);
    };

    return (
        <css.wrapPopup>
            <InnerPop show={show} dataCy={'sharePopup'} title={t('share')} >
                <><css.top />
                    <css.wrapAll> 
                        <css.title>{t('imageShare')}</css.title>
                        <ImagePopup
                            imageProps={{
                                size: {height: 200, width: 200},
                                image: image,
                                imageId: '',
                                setImage: imageHelpers.setValue,
                            }}
                            fieldName={'postImage'}
                        />
                        <css.shareDetails>
                            <css.title>{t('socialShare')}</css.title>
                            <css.shareShare>
                                {isMobile?
                                    <css.buttons><Btn className={''} onClick={mobileShareHandler} disabled={false}>{t('share')}</Btn></css.buttons>
                                    :
                                    sharingOptions.map((item, index) => <css.shareItem key={index} onClick={()=>share(item.text)}>
                                        <css.shareItemImg img={item.image}/>
                                        <css.shareItemText>{t(item.text)}</css.shareItemText>
                                    </css.shareItem>)}
                            </css.shareShare>
                        </css.shareDetails>
                    </css.wrapAll></>
                {!isMobile&&<css.shareClose><Btn className={'white'} onClick={show.close} disabled={false}>{t('close')}</Btn></css.shareClose>}
            </InnerPop>
        </css.wrapPopup>
    );
};

export default CustomSharePopup;